/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Injectable } from '@angular/core';
import { TreeNode } from 'app/shared/models/tree-node.model';

@Injectable({providedIn: 'root'})
export class TreeNodeHelperService {
  constructor() {

  }
  
  createNodeFromResponse(response: any, parentBreadcrumb: string, parent: TreeNode = null): TreeNode {
    const tree = new TreeNode(response.id, response.name, response.hasChildren,
        true, true, false, true,
        [], [],
        false, parent, parentBreadcrumb, response.nodeType);

    if (response.children) {
      tree.children = response.children.map(item => this.createNodeFromResponse(item, parentBreadcrumb + '/' + response.name, tree))
    }
        
    tree.allowActions = true;
    tree.expanded = true;
    return tree;
  }

  findNodeFromIdAndType(nodeId: number, nodeType: string, tree: TreeNode): TreeNode {
    return this.searchTree(tree, nodeId, nodeType);
  }

  searchTree(tree: TreeNode, nodeId: number, nodeType: string): TreeNode {
    if (tree.id === nodeId && tree.nodeType === nodeType) {
      return tree;
    } else if (tree.children != null) {
      let i: number;
      let result = null;
      for (i = 0; result == null && i < tree.children.length; i++) {
        result = this.searchTree(tree.children[i], nodeId, nodeType);
      }
      return result;
    }
    return null;
  }

  removeAllFocus(tree) {
    this.removeFocusRecurse(tree);
  }

  private removeFocusRecurse(tree: TreeNode) {
    tree.focus = false;
    tree.children.forEach(child => {
      this.removeFocusRecurse(child);
    });
  }

}
